import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import './ChangePassword.css';

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState(""); // Message to display any errors or success
  const navigate = useNavigate();

  // Regex for password validation (at least one uppercase letter, one special character, and minimum 8 characters)
  const passwordValidationRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*\W)(?=.{8,})/;


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if any of the fields are empty
    if (!currentPassword || !newPassword || !confirmPassword) {
      const errorMessage = "Empty fileds are not accepted.";
      setMessage(errorMessage);
      alert(errorMessage); // Alert if any field is empty
      window.location.reload(); // Refresh the page after alert
      return;
    }

    // Check if new password and confirm password match
    if (newPassword !== confirmPassword) {
      const errorMessage = "New password and confirmation do not match.";
      setMessage(errorMessage);
      alert(errorMessage); // Alert for mismatch
      window.location.reload(); // Refresh the page after alert
      return;
    }
    if (newPassword.length < 8) {
      const errorMessage = "Password must be at least 8 characters long.";
      setMessage(errorMessage);
      alert(errorMessage); // Alert for password length issue
      window.location.reload(); // Refresh the page after alert
      return;
    }

    // Validate new password strength
    if (!passwordValidationRegex.test(newPassword)) {
      const errorMessage = "Password must contain atleast one uppercase [A-Z] letter , atleast one number [0-9]and one special character.";
      setMessage(errorMessage);
      alert(errorMessage); // Alert for password strength issue
      window.location.reload(); // Refresh the page after alert
      return;
    }

    // Check if user is logged in by verifying token
    const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).token : null;

    if (!token) {
      const errorMessage = "You must be logged in to change your password.";
      setMessage(errorMessage);
      alert(errorMessage); // Alert for missing token
      window.location.reload(); // Refresh the page after alert
      return;
    }

    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) {
      const errorMessage = "Invalid token. Please log in again.";
      setMessage(errorMessage);
      alert(errorMessage); // Alert for invalid token
      localStorage.removeItem('user'); // Clear invalid token
      navigate('/login'); // Redirect to login
      return;
    }

    try {
      // Make API request to change password
      const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/user/change-password`, {
        currentPassword,
        newPassword
      }, {
        headers: {
          Authorization: `Bearer ${token}`,  // Include token in the request header
        },
      });

      // console.log(response);
      // Handle success response
      const successMessage = 'Password changed successfully!';
      setMessage(successMessage);
      alert(successMessage); // Alert on success
      window.location.reload(); // Refresh the page after alert
      navigate('/'); // Or wherever you want to redirect after successful password change
    } catch (error) {
      // Handle error (e.g., invalid token or backend issue)
      console.error('Error changing password:', error);
      const errorMessage = 'Failed to change password. Please try again.';
      setMessage(errorMessage);
      alert(errorMessage); // Alert on failure
      window.location.reload(); // Refresh the page after alert
    }
  };

  return (
    <div className="change-password-container">
      <div className="form-container-ch">
        <div className="container-Header">
          <h3>Change Password</h3>
        </div>
        <div className="container-body">
          <div className="form-group-ch">
            <label className="ch-pass">Old Password</label>
            <input className="ch-in"
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group-ch">
            <label className="ch-pass">New Password</label>
            <input className="ch-in"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group-ch">
            <label className="ch-pass">Confirm New Password</label>
            <input className="ch-in"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group-ch">
            <button className="change-btn" onClick={handleSubmit}>
              Change
            </button>
          </div>
        </div>
        {/* Display the message below the form */}
        {message && <div className="message">{message}</div>}
      </div>
    </div>
  );
};

export default ChangePassword;
